import script from "./MyPoolBalancesCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyPoolBalancesCard.vue?vue&type=script&setup=true&lang=ts"

import "./MyPoolBalancesCard.vue?vue&type=style&index=0&id=e289aac4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e289aac4"]])

export default __exports__